unit f_scrivitrasporti;

{$mode objfpc}

interface

uses
  Classes, SysUtils, js, web, un_widget, un_tquery, w_table, un_generator, f_selezione, un_user;

type

  { TFrmScriviTrasporti }

  TFrmScriviTrasporti = class(TWidget)
    nuovorecord :String;
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
    idtrasporto:integer;
    procedure salva_click(Event: TJSEvent); async;
    procedure chiudi_click(Event: TJSEvent); async;

  private

  published
    procedure CompilaCampi; async;
    procedure ControlloCompilazioneCampi; async;
    procedure idautista_click; async;
    procedure idaccompagnatore_click; async;
    procedure idautomezzo_click; async;
    QryScriviKm: TQuery;
    iddata: TJSHTMLSelectElement;
    idora: TJSHTMLSelectElement;
    idviaggio: TJSHTMLSelectElement;
    idannullato: TJSHTMLSelectElement;
    dtscadenza: TJSHTMLSelectElement;
    idautista: TJSHTMLSelectElement;
    dsautista: TJSHTMLSelectElement;
    idaccompagnatore: TJSHTMLSelectElement;
    dsaccompagnatore: TJSHTMLSelectElement;
    idautomezzo: TJSHTMLSelectElement;
    dsautomezzo: TJSHTMLSelectElement;

  end;

implementation

{$R *.html}

{ TFrmScriviTrasporti }

procedure TFrmScriviTrasporti.AfterRender;
begin

//

end;

procedure TFrmScriviTrasporti.AfterDomAppend;
begin

      Await(CompilaCampi);

end;

procedure TFrmScriviTrasporti.salva_click(Event: TJSEvent);
begin

  ControlloCompilazioneCampi;

  QryScriviKm.edit;
  QryScriviKm.FieldByName('idautista').AsString := idautista.value;
  QryScriviKm.FieldByName('dsautista').AsString := dsautista.value;
  QryScriviKm.FieldByName('idaccompagnatore').AsString := idaccompagnatore.value;
  QryScriviKm.FieldByName('dsaccompagnatore').AsString := dsaccompagnatore.value;
  QryScriviKm.FieldByName('idautomezzo').AsString := idautomezzo.value;
  QryScriviKm.FieldByName('dsautomezzo').AsString := dsautomezzo.value;
  QryScriviKm.Post;
  QryScriviKm.ApplyUpdates;

  ShowMessage('Modifica eseguita con successo');

  Close();

end;

procedure TFrmScriviTrasporti.chiudi_click(Event: TJSEvent);
begin

  Close;

end;

procedure TFrmScriviTrasporti.CompilaCampi;
begin

  QryScriviKm.Close;
  QryScriviKm.SQL.Text:= ' SELECT idtrasporto, dtdata, horapartenza, idautomezzo, dsautomezzo, '
                        + ' dstiporichiesta, idautista, dsautista, idaccompagnatore, '
                        + ' dsaccompagnatore, dsfruitore '
                        + ' from ta_trasporti  '
                        + ' where idtrasporto = ' + IntToStr(idtrasporto);
  AWait(QryScriviKm.Open);


  iddata.value := QryScriviKm.FieldByName('dtdata').AsString;
  idora.value := QryScriviKm.FieldByName('horapartenza').AsString;
  idviaggio.value := 'tipo  richiesta: ' + QryScriviKm.FieldByName('dstiporichiesta').AsString
    + ' - destinazione: ' + QryScriviKm.FieldByName('dsfruitore').AsString
    + ' - mezzo: '  + QryScriviKm.FieldByName('dsautomezzo').AsString;
  idautista.value := QryScriviKm.FieldByName('idautista').AsString;
  dsautista.value := QryScriviKm.FieldByName('dsautista').AsString;
  idaccompagnatore.value := QryScriviKm.FieldByName('idaccompagnatore').AsString;
  dsaccompagnatore.value := QryScriviKm.FieldByName('dsaccompagnatore').AsString;
  idautomezzo.value := QryScriviKm.FieldByName('idautomezzo').AsString;
  dsautomezzo.value := QryScriviKm.FieldByName('dsautomezzo').AsString;

end;

procedure TFrmScriviTrasporti.ControlloCompilazioneCampi;
begin
  // controllo se i campi sono compilati
    //if idkmarrivo.value = '' then
    //  begin
    //    ShowMessage('Devi inserire la categoria');
    //    Exit;
    //  end;
end;

procedure TFrmScriviTrasporti.idautista_click;
var
  FrmSel: TFrmSelezione;

  // Valori originali degli altri campi
  OldIdAccompagnatore: string;
  OldDsAccompagnatore: string;
  OldIdAutomezzo: string;
  OldDsAutomezzo: string;

  // Valore selezionato
  NewIdAutista: string;
  NewDsAutista: string;
begin
  // Salviamo i valori attuali degli ALTRI campi
  OldIdAccompagnatore := idaccompagnatore.Value;
  OldDsAccompagnatore := dsaccompagnatore.Value;
  OldIdAutomezzo := idautomezzo.Value;
  OldDsAutomezzo := dsautomezzo.Value;

  FrmSel := TFrmSelezione.Create;

  FrmSel.OpenQrySeleziona := procedure async
  begin
    FrmSel.CloseForm := True;

    FrmSel.QrySeleziona.Close;

    FrmSel.QrySeleziona.SQL.Text :=
      'select idanagrafica, dsragionesociale ' +
      'from an_anagrafiche ' +
      'where dstipo = ''AUAC'' ' +
      'order by dsragionesociale';

    await(FrmSel.QrySeleziona.Open);
  end;

  if await(FrmSel.Show) = mrOK then
  begin
    // Acquisiamo SUBITO il valore scelto
    NewIdAutista :=
      FrmSel.QrySeleziona.FieldByName('idanagrafica').AsString;

    NewDsAutista :=
      FrmSel.QrySeleziona.FieldByName('dsragionesociale').AsString;

    // Modifichiamo SOLAMENTE l'autista
    idautista.Value := NewIdAutista;
    dsautista.Value := NewDsAutista;

    // Ripristiniamo gli altri campi al loro valore originale
    idaccompagnatore.Value := OldIdAccompagnatore;
    dsaccompagnatore.Value := OldDsAccompagnatore;

    idautomezzo.Value := OldIdAutomezzo;
    dsautomezzo.Value := OldDsAutomezzo;
  end;
end;


procedure TFrmScriviTrasporti.idaccompagnatore_click;
var
  FrmSel: TFrmSelezione;

  // Valori originali degli altri campi
  OldIdAutista: string;
  OldDsAutista: string;
  OldIdAutomezzo: string;
  OldDsAutomezzo: string;

  // Valore selezionato
  NewIdAccompagnatore: string;
  NewDsAccompagnatore: string;
begin
  // Salviamo i valori attuali degli ALTRI campi
  OldIdAutista := idautista.Value;
  OldDsAutista := dsautista.Value;
  OldIdAutomezzo := idautomezzo.Value;
  OldDsAutomezzo := dsautomezzo.Value;

  FrmSel := TFrmSelezione.Create;

  FrmSel.OpenQrySeleziona := procedure async
  begin
    FrmSel.CloseForm := True;

    FrmSel.QrySeleziona.Close;

    FrmSel.QrySeleziona.SQL.Text :=
      'select idanagrafica, dsragionesociale ' +
      'from an_anagrafiche ' +
      'where dstipo in (''AC'', ''AUAC'') ' +
      'order by dsragionesociale';

    await(FrmSel.QrySeleziona.Open);
  end;

  if await(FrmSel.Show) = mrOK then
  begin
    // Acquisiamo SUBITO il valore scelto
    NewIdAccompagnatore :=
      FrmSel.QrySeleziona.FieldByName('idanagrafica').AsString;

    NewDsAccompagnatore :=
      FrmSel.QrySeleziona.FieldByName('dsragionesociale').AsString;

    // Modifichiamo SOLAMENTE l'accompagnatore
    idaccompagnatore.Value := NewIdAccompagnatore;
    dsaccompagnatore.Value := NewDsAccompagnatore;

    // Ripristiniamo gli altri campi al loro valore originale
    idautista.Value := OldIdAutista;
    dsautista.Value := OldDsAutista;

    idautomezzo.Value := OldIdAutomezzo;
    dsautomezzo.Value := OldDsAutomezzo;
  end;
end;


procedure TFrmScriviTrasporti.idautomezzo_click;
var
  FrmSel: TFrmSelezione;

  // Valori originali degli altri campi
  OldIdAutista: string;
  OldDsAutista: string;
  OldIdAccompagnatore: string;
  OldDsAccompagnatore: string;

  // Valore selezionato
  NewIdAutomezzo: string;
  NewDsAutomezzo: string;
begin
  // Salviamo i valori attuali degli ALTRI campi
  OldIdAutista := idautista.Value;
  OldDsAutista := dsautista.Value;
  OldIdAccompagnatore := idaccompagnatore.Value;
  OldDsAccompagnatore := dsaccompagnatore.Value;

  FrmSel := TFrmSelezione.Create;

  FrmSel.OpenQrySeleziona := procedure async
  begin
    FrmSel.CloseForm := True;

    FrmSel.QrySeleziona.Close;

    FrmSel.QrySeleziona.SQL.Text :=
      'select idautomezzo, dsautomezzo ' +
      'from ta_automezzi ' +
      'order by dsautomezzo';

    await(FrmSel.QrySeleziona.Open);
  end;

  if await(FrmSel.Show) = mrOK then
  begin
    // Acquisiamo SUBITO il valore scelto
    NewIdAutomezzo :=
      FrmSel.QrySeleziona.FieldByName('idautomezzo').AsString;

    NewDsAutomezzo :=
      FrmSel.QrySeleziona.FieldByName('dsautomezzo').AsString;

    // Modifichiamo SOLAMENTE l'automezzo
    idautomezzo.Value := NewIdAutomezzo;
    dsautomezzo.Value := NewDsAutomezzo;

    // Ripristiniamo gli altri campi al loro valore originale
    idautista.Value := OldIdAutista;
    dsautista.Value := OldDsAutista;

    idaccompagnatore.Value := OldIdAccompagnatore;
    dsaccompagnatore.Value := OldDsAccompagnatore;
  end;
end;

initialization
  RegisterWeb(TFrmScriviTrasporti);

end.

